import styled from 'styled-components';
import Button from '@whitelabel/component-library/src/components/Button';
import { themeColor } from '@whitelabel/helpers/style/colors';
import { fontWeight } from '@whitelabel/helpers/style/type';

// Offset below the 4rem primary nav bar
export const StyledCollapse = styled.div<{ $isOpen: boolean }>`
  width: max(100vw, 100%);
  z-index: 1000;
  background: ${themeColor('tertiaryBg')};
  height: calc(100vh - 4rem);
  padding: 1rem;
  position: absolute;
  top: 4rem;
  transition: left 1s, visibility 1s;
  left: ${({ $isOpen }) => ($isOpen ? '0' : 'max(100vw, 100%)')};
  visibility: ${({ $isOpen }) => ($isOpen ? 'visible' : 'hidden')};
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  touch-action: manipulation;

  @media print {
    display: none;
  }
`;

export const StyledScrollableContainer = styled.div`
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  touch-action: manipulation;
  background-color: inherit;
  height: calc(100vh - 12rem);
  width: 100%;

  h1 {
    color: ${themeColor('heading')};
  }

  .nav-settings-submenu {
    font-weight: ${fontWeight('black')};
  }
`;

export const StyledNavCustomer = styled.div`
  .customer-data {
    margin-bottom: 1rem;
  }
`;

export const StyledMainButton = styled(Button)`
  width: calc(100% - 2rem);
  position: fixed;
  bottom: 2rem;
  z-index: 1002;
`;
